<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    class="io-card"
    :class="item && item.link ? 'cursor-pointer' : ''"
    @click="redirect"
  >
    <div
      v-if="item"
      class="io-card-header"
    >
      <div
        v-if="item.icon"
        class="io-card-header-icon"
      >
        <i
          class="fill-current text-white fa-2x"
          :class="item.icon"
        />
      </div>
      <div class="flex flex-column justify-center">
        <p
          v-if="item.title"
          class="io-card-title"
        >
          {{ item.title }}
        </p>
        <p
          v-if="item.subtitle"
          class="io-card-subtitle"
        >
          {{ item.subtitle }}
        </p>
      </div>
      <slot name="actions" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: false,
    },
  },
  methods: {
    redirect(e) {
      if (this.item && this.item.link && e.target.classList.value.includes('io-card')) {
        window.location.href = this.item.link;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.io-card {
  @apply bg-white
  rounded-2xl
  shadow-card;

  &-header {
    @apply flex
    mb-7;

    &-icon {
      @apply flex
      items-center
      justify-center
      rounded-full
      mr-2.5;
      font-size: 3.125rem;
      width: 1em;
      height: 1em;
      background-color: #20535c;
      background-color: var(--company-main-primary);

      > i, > svg {
        font-size: .52em;
      }
    }
  }

  &-title {
    @apply text-xl
    text-gray2;
  }

  &-value {
    color: var(--company-main-primary);
    @apply text-5xl
    font-bold
    mb-4;
  }

  &:not(div):hover {
    text-decoration: none;
  }
}
</style>

<style lang="scss" scoped>
.io-card {
  &-measure {
    @apply text-gray1;
  }

  &-subtitle {
    @apply text-gray2;
  }
}
</style>
